import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'
import { formatPrice } from '../../../helpers'

const SelectBankModal = ({
  show,
  onHide,
  totalFee,
  loadingBanks,
  bankAccounts,
  selectedBankId,
  setSelectedBankId,
  submittingWithdrawal,
  handleConfirmWithdrawal,
  onOpenAddBank
}) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: '1.2em', fontWeight: 'bold', color: '#00a651' }}>
          Pilih Rekening Penarikan
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ backgroundColor: '#f4fbf7', border: '1px solid #b7ebcb', borderRadius: '8px', padding: '12px 16px', marginBottom: '16px' }}>
          <span style={{ fontSize: '0.85em', color: '#555', display: 'block' }}>Jumlah komisi yang ditarik:</span>
          <span style={{ fontSize: '1.3em', fontWeight: 'bold', color: '#00a651' }}>{formatPrice(totalFee, 'Rp.')}</span>
        </div>

        {loadingBanks ? (
          <div style={{ textAlign: 'center', padding: '20px 0', color: '#666' }}>
            Memuat data rekening...
          </div>
        ) : bankAccounts.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <p style={{ color: '#666', marginBottom: '15px' }}>Anda belum menambahkan rekening bank untuk penarikan.</p>
            <button
              type="button"
              onClick={onOpenAddBank}
              style={{
                padding: '10px 20px',
                borderRadius: '6px',
                border: 'none',
                backgroundColor: '#00a651',
                color: '#fff',
                fontWeight: 'bold',
                cursor: 'pointer',
                outline: 'none'
              }}
            >
              + Tambah Rekening Sekarang
            </button>
          </div>
        ) : (
          <div>
            <p style={{ fontSize: '0.9em', fontWeight: '600', color: '#444', marginBottom: '10px' }}>
              Pilih rekening bank tujuan:
            </p>
            {bankAccounts.map((account) => {
              const isSelected = Number(selectedBankId) === Number(account.id)
              return (
                <div
                  key={account.id}
                  onClick={() => setSelectedBankId(account.id)}
                  style={{
                    border: isSelected ? '2px solid #00a651' : '1px solid #e0e0e0',
                    backgroundColor: isSelected ? '#f0faf4' : '#fff',
                    borderRadius: '8px',
                    padding: '12px 16px',
                    marginBottom: '10px',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    transition: 'all 0.15s ease'
                  }}
                >
                  <input
                    type="radio"
                    name="selectedBank"
                    checked={isSelected}
                    onChange={() => setSelectedBankId(account.id)}
                    style={{ accentColor: '#00a651', transform: 'scale(1.2)' }}
                  />
                  <div>
                    <span style={{
                      display: 'inline-block',
                      backgroundColor: '#00a651',
                      color: '#fff',
                      fontSize: '0.7em',
                      fontWeight: 'bold',
                      padding: '1px 6px',
                      borderRadius: '4px',
                      marginBottom: '2px',
                      textTransform: 'uppercase'
                    }}>
                      {account.bank_name}
                    </span>
                    <div style={{ fontWeight: 'bold', color: '#222', fontSize: '0.95em' }}>
                      {account.account_number}
                    </div>
                    <span style={{ fontSize: '0.85em', color: '#666' }}>
                      a.n {account.account_holder_name}
                    </span>
                  </div>
                </div>
              )
            })}

            <div style={{ textAlign: 'right', marginTop: '10px' }}>
              <button
                type="button"
                onClick={onOpenAddBank}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#00a651',
                  fontSize: '0.85em',
                  fontWeight: '600',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  outline: 'none'
                }}
              >
                + Tambah Rekening Lain
              </button>
            </div>

            <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              <button
                type="button"
                onClick={onHide}
                style={{
                  padding: '8px 16px',
                  borderRadius: '6px',
                  border: '1px solid #ccc',
                  background: '#fff',
                  color: '#555',
                  cursor: 'pointer',
                  outline: 'none'
                }}
              >
                Batal
              </button>
              <button
                type="button"
                onClick={handleConfirmWithdrawal}
                disabled={submittingWithdrawal || !selectedBankId}
                style={{
                  padding: '8px 20px',
                  borderRadius: '6px',
                  border: 'none',
                  background: selectedBankId ? '#00a651' : '#ccc',
                  color: '#fff',
                  fontWeight: 'bold',
                  cursor: selectedBankId ? 'pointer' : 'not-allowed',
                  outline: 'none'
                }}
              >
                {submittingWithdrawal ? 'Memproses...' : 'Konfirmasi & Ajukan'}
              </button>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  )
}

SelectBankModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  totalFee: PropTypes.number.isRequired,
  loadingBanks: PropTypes.bool.isRequired,
  bankAccounts: PropTypes.array.isRequired,
  selectedBankId: PropTypes.any,
  setSelectedBankId: PropTypes.func.isRequired,
  submittingWithdrawal: PropTypes.bool.isRequired,
  handleConfirmWithdrawal: PropTypes.func.isRequired,
  onOpenAddBank: PropTypes.func.isRequired
}

export default SelectBankModal
